import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import Grid from '@mui/material/Grid';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';

import CaseAccordion from '../../CaseAccordion';
import NoAccess from '../../NoAccess';
import Button from '../../../../../shared/Button';
import Dropzone from '../../../../../shared/dropzone/Dropzone';
import Input from '../../../../../shared/Input';

import { updateCase } from '../../../../../../actions/casesActions';
import { caseConstants } from '../../../../../../constants';

const Step9 = ({ onClose, activeCase, updateCase, toggleModal, userId }) => {
  const [date, setDate] = useState(moment());
  const [trackingNumber, setTrackingNumber] = useState('');
  const [courier, setCourier] = useState('');

  const [cocDocument, setCocDocument] = useState([]);
  const [uploadedCocDocument, setUploadedCocDocument] = useState({});

  const handleSubmit = () => {
    if (!date) return;

    const now = moment().format();
    const filesData = activeCase.files?.length ? [...activeCase.files] : [];
    const { fileTypes, statuses } = caseConstants;

    cocDocument.forEach((file) => {
      filesData.push({
        id: `${activeCase.id}_${fileTypes.coc}_${file.name}`,
        name: file.name,
        type: fileTypes.coc,
        date: now,
        userId,
      });
    });

    const activity = [
      { ...caseConstants.caseNotifications[9].success, date: now, userId },
      ...activeCase.activity,
    ];

    const dispatchInfo = {
      ...activeCase.dispatchInfo,
      dispatchDate: date.format(),
      trackingNumber,
      courier,
    };

    updateCase({
      ...activeCase,
      files: filesData,
      step: 10,
      activity,
      completionDates: { ...activeCase.completionDates, step9: now },
      completedBy: { ...activeCase.completedBy, step9: userId },
      dispatchInfo,
      status: statuses.inProgress,
    }).then(() => onClose());
  };

  const handleUploadCocDocument = (files) => {
    const uploads = { ...uploadedCocDocument };
    files.forEach((file) => (uploads[file.name] = false));

    setUploadedCocDocument(uploads);
    setCocDocument((prev) => [
      ...prev,
      ...files.filter((file) => !prev.some((coc) => coc.name === file.name)),
    ]);
  };

  const handleRemoveCocDocument = (name) => {
    const uploads = { ...uploadedCocDocument };
    delete uploads[name];
    setUploadedCocDocument(uploads);
    setCocDocument(cocDocument.filter((file) => file.name !== name));
  };

  const onUploadCocDocumentComplete = (name) => {
    setUploadedCocDocument((prev) => ({ ...prev, [name]: true }));
  };

  const handleClose = () => {
    cocDocument.length ? toggleModal(true) : onClose();
  };

  console.log(activeCase)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="case-step-container">
        <div className="case-step-content">
          <div className="case-step-row">
            <div className="column">
              <div className="modal-item-circle">9</div>
            </div>

            <div className="modal-item-content">
              <div>Dispatch Confirmation</div>

              {activeCase.access ? (
                <div className="modal-item-block">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="field-container">
                        <div className="field-title">Dispatch date</div>
                        <div className="field-content">
                          <DatePicker
                            desktopModeMediaQuery="(min-width: 0px)"
                            value={date}
                            onChange={(newDate) => setDate(newDate)}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                variant: 'standard',
                              },
                            }}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container className="m-t-md" spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="field-container">
                        <div className="field-title">Tracking No.</div>
                        <Input
                          value={trackingNumber}
                          onChange={setTrackingNumber}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="field-container">
                        <div className="field-title">Courier</div>
                        <Input
                          value={courier}
                          onChange={setCourier}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                      <div className="block-header">Attach CoC Document</div>
                      <Dropzone
                        files={cocDocument}
                        onUpload={handleUploadCocDocument}
                        onRemove={handleRemoveCocDocument}
                        type="pdf"
                        icon="coc"
                        withProgress
                        path={`${activeCase.id}/${activeCase.id}`}
                        suffix="coc"
                        onUploadComplete={onUploadCocDocumentComplete}
                      />
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <NoAccess />
              )}
            </div>
          </div>

          <CaseAccordion currentStep={9} />
        </div>

        <div className="case-modal-actions">
          <div className="secondary pointer" onClick={handleClose}>
            Close
          </div>
          <Button
            text="Submit"
            color="primary"
            onClick={handleSubmit}
            disabled={!activeCase.access}
          />
        </div>
      </div>
    </LocalizationProvider>
  );
};

Step9.propTypes = {
  activeCase: PropTypes.object,
  onClose: PropTypes.func,
  updateCase: PropTypes.func,
};

const mapStateToProps = (state) => ({
  activeCase: state.cases.activeCase,
  userId: state.user.currentUser.uid,
});

const mapDispatchToProps = (dispatch) => ({
  updateCase: (newCase) => dispatch(updateCase(newCase, 9)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step9);
